import './loadingSpinner.scss';

interface LoadingSpinnerProps {
    white?: boolean;
}

const LoadingSpinner = ({ white = false }: LoadingSpinnerProps) => {
    const spinnerColor = white ? '#ffffff' : '#000000';
    return (
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="loading-spinner"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.3409 6.22105C14.8473 5.25619 13.0747 4.81647 11.3033 4.97133C9.53188 5.12619 7.86254 5.86681 6.55897 7.0762C5.2554 8.2856 4.39191 9.89483 4.10491 11.6497C3.8179 13.4046 4.12373 15.205 4.9741 16.7667C5.82446 18.3284 7.17088 19.5622 8.80067 20.2733C10.4305 20.9845 12.2507 21.1323 13.9739 20.6936C15.6971 20.2548 17.225 19.2545 18.3163 17.8505C19.4076 16.4466 20 14.7191 20 12.9409C20 12.3886 20.4477 11.9409 21 11.9409C21.5523 11.9409 22 12.3886 22 12.9409C22 15.1637 21.2595 17.323 19.8954 19.078C18.5313 20.8329 16.6214 22.0833 14.4674 22.6318C12.3134 23.1802 10.0381 22.9953 8.00083 22.1064C5.96359 21.2175 4.28057 19.6752 3.21762 17.7231C2.15466 15.771 1.77237 13.5205 2.13113 11.3269C2.48989 9.1333 3.56925 7.12176 5.19871 5.61002C6.82817 4.09828 8.91484 3.1725 11.1291 2.97892C13.3434 2.78535 15.5591 3.33501 17.4261 4.54108C17.89 4.84076 18.0232 5.45977 17.7235 5.92368C17.4238 6.38759 16.8048 6.52073 16.3409 6.22105Z"
                fill={spinnerColor}
            />
        </svg>
    );
};

export default LoadingSpinner;